__turbopack_context__.v({
  "shimmer": "DateCountdown-module-scss-module__JE9bmW__shimmer",
  "skeletonCountdown": "DateCountdown-module-scss-module__JE9bmW__skeletonCountdown",
  "skeletonText": "DateCountdown-module-scss-module__JE9bmW__skeletonText",
  "skeletonTitle": "DateCountdown-module-scss-module__JE9bmW__skeletonTitle",
});
